import _default from './Reveal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Reveal/index.js
// module id = 1523
// module chunks = 1